import { getDifferentiationPalette } from '@kistler/skybase-ui/skybase-core/colors'

export const getVariousColors = () => {
  return getDifferentiationPalette('smaller')
}
